export default "__VITE_ASSET__CpLOvkMb__"